import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMeasuremetResults, updateMeasuremetResults } from '../services/report/function';
import { measurementKeys } from '../services/report/key';
import { MeasurementTableBlockConfig } from '../services/config/type';
import { selectByParamCodes } from '../services/report/selector'
import { localStateKeys } from '../utils/reportviewutils';
import { /*MeasurementResult,*/ MeasurementResultValueForUpdate } from '../services/report/type';
import '../styles/main.css';

function NumericTable({targetConfig}:{targetConfig: MeasurementTableBlockConfig}) {
  // get num of studies
  const queryClient = useQueryClient();
  const numBlocks = queryClient.getQueryData<number>(localStateKeys.maxBlocks);
console.log('NumericTable : numBlocks = ' + numBlocks);


  const { status, data, error } = useQuery({
    queryKey: measurementKeys.all,
    queryFn: getMeasuremetResults,
    select: selectByParamCodes(targetConfig.paramCodes),
    /*
    select: (data: MeasurementResult[]) : MeasurementResult[] => {
      return data.filter(elem => props.paramCodes.includes(elem.paramCode));
    },
    */
    staleTime: Infinity,
    meta: { numBlocks : numBlocks, numParams : 10, numResults : 10 },
  });

  const mutation = useMutation({
    mutationFn: updateMeasuremetResults,
    onSuccess: (data) => {
      queryClient.setQueryData(
        measurementKeys.all, data
      )
    },
  });

  // if (isPending) 
  if (status === 'pending') {
    return <span key='ispending'></span>
  }

  // if (isError) 
  if (status === 'error') {
    return <span key='iserror'>Error: {error.message}</span>
  }


  // event handler 
  const handleMeasValueDblClick = (event: React.MouseEvent<HTMLTableCellElement>) => {
    let numVal = Number(event.currentTarget.dataset.value);
    const valForUpdate : MeasurementResultValueForUpdate = {
      measInsUID: event.currentTarget.dataset.measinsuid,
      updateType: '',
      updateValue: '' + Math.abs(numVal - Math.random() * 50).toFixed(2),
    }
    mutation.mutate(valForUpdate);
  }

  return (
    <table key={'tbl_'+targetConfig.blockName} className="numeric-table">
      { 
        (() => {
          console.log('block name ['+targetConfig.blockName+'] is now rendering...');
          return null;
        })() && undefined
      }
      <thead>
        <tr>
        {
          //console.log(data) || console.log(performance.now()) ||
          <th scope="row">{targetConfig.blockName}</th>
          
        }
          <td colSpan={13}></td>        
        </tr>
      </thead>
      <thead>
        <tr key={'h'}>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">1<a className="delete_btn" href="#">x</a></th>
          <th scope="col">2<a className="delete_btn" href="#">x</a></th>
          <th scope="col">3<a className="delete_btn" href="#">x</a></th>
          <th scope="col">4<a className="delete_btn" href="#">x</a></th>
          <th scope="col">5<a className="delete_btn" href="#">x</a></th>
          <th scope="col">6<a className="delete_btn" href="#">x</a></th>
          <th scope="col">7<a className="delete_btn" href="#">x</a></th>
          <th scope="col">8<a className="delete_btn" href="#">x</a></th>
          <th scope="col">9<a className="delete_btn" href="#">x</a></th>
          <th scope="col">10<a className="delete_btn" href="#">x</a></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
      {data.map((param) => (
        <tr key={param.paramCode}
            data-paramcode={param.paramCode}
            data-innerparamid={param.innerParamID}
        >
          <th>{param.paramCode}</th>
          <td>
            <select name="value-type">
              <option value="First">First</option>
              <option value="Last">Last</option>
              <option value="Min">Min</option>
              <option value="Max">Max</option>
              <option value="Avg">Avg</option>
            </select>
          </td>
          <td>value</td>
          {param.eachResultValues?.map((val) => (
            <td key={val.paramCode + val.measInsUID} 
                onDoubleClick={handleMeasValueDblClick}
                data-paramcode={val.paramCode}
                data-innerparamid={val.innerParamID}
                data-measinsuid={val.measInsUID}
                data-value={val.value}
            >
              {
                val.modifiedValue ?? val.value
              }
            </td>
          ))}            
          <td><a className="delete_btn" href="#">x</a></td>
        </tr>
      ))}      

      </tbody>
      <tfoot>
        <tr>
          <th scope="row">dummy_calc</th>
          <td></td>
          <td>calvalue</td>
          <td colSpan={11}></td>
        </tr>
      </tfoot>
    </table>
  )
}

export default NumericTable;